"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const config_1 = __importDefault(require("./config"));
const apiType_1 = require("../apiType");
const clconnect_1 = __importDefault(require("./config/clconnect"));
const mock_1 = __importDefault(require("./config/mock"));
const pbp10_1 = __importDefault(require("./config/pbp10"));
const di_1 = require("@almservices-cl/di");
const config_consts_1 = require("./config.consts");
class Container extends di_1.Container {
    constructor(environment, cache, host, entries, recipes) {
        super(entries || config_1.default.container.entries, recipes || config_1.default.container.recipes);
        this.warmUp = async () => {
            // await BaseContainer.prototype.warmUp.call(this);
            this.get("DATE_TIME_PROVIDER");
            this.get("DATE_TIME_MODIFIER");
            this.get("SYSTEM_DATE_TIME_PROVIDER");
            this.get("SYSTEM_DATE_TIME_MODIFIER");
            this.get("HTTP_CLIENT");
            this.get("USER_DATE_TIME_CONFIG");
            this.get("SYSTEM_DATE_TIME_CONFIG");
            this.get("DATE_TIME_BRIDGE");
        };
        let envEntries = {};
        if (environment === apiType_1.apiType.CL_CONNECT) {
            envEntries = clconnect_1.default.container.entries;
        }
        if (environment === apiType_1.apiType.MOCK) {
            envEntries = mock_1.default.container.entries;
        }
        if (environment === apiType_1.apiType.PBP_10) {
            envEntries = pbp10_1.default.container.entries;
        }
        Object.keys(envEntries).forEach((entryName) => {
            this.registerFactory(entryName, envEntries[entryName]);
        });
        let envRecipes = {};
        if (environment === apiType_1.apiType.CL_CONNECT) {
            envRecipes = clconnect_1.default.container.recipes;
        }
        if (environment === apiType_1.apiType.MOCK) {
            envRecipes = mock_1.default.container.recipes;
        }
        if (environment === apiType_1.apiType.PBP_10) {
            envRecipes = pbp10_1.default.container.recipes;
        }
        Object.keys(envRecipes).forEach((recipeName) => {
            this.registerRecipe(recipeName, envRecipes[recipeName]);
        });
        this.registerValue("CONFIG_ENVIRONMENT", environment);
        this.registerValue("CONFIG_HOST", host);
        this.registerValue("CACHE", cache);
        this.registerValue(config_consts_1.IS_LOGGER_ENABLED, true);
    }
}
exports.default = Container;
//# sourceMappingURL=Container.js.map